import styled from "@emotion/styled";
import PropTypes from "prop-types";
import React from "react";

import ContentContainer from "~/components/layout/ContentContainer";
import SectionWrapper from "~/components/layout/SectionWrapper";
import { screenReaderText } from "~/styles/screenReaderText";

import useStringTranslation from "~/hooks/translations/useStringTranslation";

import Cta from "~/components/Cta";

const ScreenReaderText = styled.h2`
    ${screenReaderText}
`;

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

const Col = styled.div`
    display: flex;
    width: 100%;
    margin-bottom: ${({ theme, vertical }) =>
        vertical ? theme.layout.gutter : "0"};

    @media (min-width: ${({ theme }) => theme.breakpoints.tabletPortrait}) {
        width: ${({ numberOfCols }) => (numberOfCols > 3 ? `50%` : `100%`)};
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.tabletLandscape}) {
        width: ${({ numberOfCols }) =>
            numberOfCols > 3 ? `50%` : `calc(100% / ${numberOfCols})`};
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: ${({ numberOfCols }) => `calc(100% / ${numberOfCols})`};
    }
`;

const CtaBar = ({
    backgroundColor = "gray",
    sections = [],
    vertical = false,
}) => {
    let numberOfCols = sections ? sections.length : 0;

    const { supportText } = useStringTranslation([
        { text: "Support", handle: "supportText" },
    ]);

    if (numberOfCols === 4) {
        numberOfCols = 4;
    }

    if (numberOfCols > 4) {
        numberOfCols = 3;
    }

    if (vertical) {
        numberOfCols = 1;
    }

    return sections && sections.length ? (
        <SectionWrapper aria-labelledby="supportSectionLabel">
            <ScreenReaderText id="supportSectionLabel">
                {supportText}
            </ScreenReaderText>
            <ContentContainer>
                <Wrapper>
                    {sections.map(({ title, links }, index) => (
                        <Col key={index} {...{ vertical, numberOfCols }}>
                            <Cta
                                {...{ backgroundColor, links, title }}
                                inline={!vertical && sections.length === 1}
                                center={!vertical && sections.length < 3}
                            />
                        </Col>
                    ))}
                </Wrapper>
            </ContentContainer>
        </SectionWrapper>
    ) : null;
};

CtaBar.propTypes = {
    backgroundColor: PropTypes.oneOf(["white", "gray"]),
    sections: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            links: PropTypes.arrayOf(
                PropTypes.shape({
                    linkLabel: PropTypes.string.isRequired,
                    linkUrl: PropTypes.string,
                    icon: PropTypes.string,
                    type: PropTypes.oneOf(["form", "link", "document"]),
                    formId: PropTypes.number,
                    doc: PropTypes.shape({}),
                }).isRequired,
            ),
        }).isRequired,
    ).isRequired,
    vertical: PropTypes.bool,
};

export default CtaBar;
